import {
  Sheet,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  SheetContent,
} from '@/components/ui/sheet';
import { EventClickArg } from '@fullcalendar/core/index.js';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import CalendarEventForm from '@/components/elements/forms/calendarEventForm';
import DeleteCalendarEventAlert from './deleteCalendarEvent';

interface EditCalendarEventProps {
  eventSelected?: EventClickArg;
  show: boolean;
  setShow: (open: boolean) => void;
}

export default function EditCalendarEvent({
  ...props
}: EditCalendarEventProps) {
  const [showDelete, setShowDelete] = useState<boolean>(false);

  return (
    <Sheet open={props.show} onOpenChange={props.setShow}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Edit Event</SheetTitle>
          <SheetDescription>Edit the event details below</SheetDescription>
        </SheetHeader>
        <CalendarEventForm
          parentShow={props.setShow}
          eventId={props.eventSelected?.event.id}
          title={props.eventSelected?.event.title}
          startDate={props.eventSelected?.event.start}
          endDate={props.eventSelected?.event.end}
          // eventStart={props.eventSelected?.event.start}
          // eventEnd={props.eventSelected?.event?.end}
          comment={props.eventSelected?.event.extendedProps.comment}
        />
        {props.eventSelected?.event.id ? (
          <div>
            <br />
            <div className='flex gap-3 py-3'>
              <Button variant='destructive' onClick={() => setShowDelete(true)}>
                Delete Event
              </Button>
              <DeleteCalendarEventAlert
                id={props.eventSelected?.event.id}
                show={showDelete}
                setShow={setShowDelete}
                parentSetShow={props.setShow}
              />
            </div>
          </div>
        ) : (
          <></>
        )}
      </SheetContent>
    </Sheet>
  );
}
